export const getSupplyPickupBreadcrumbTitle = (requestData) => {
  if (!requestData) return "";
  return requestData.breadcrumbTitle || requestData.pageTitle || "";
};

export const DimensionUnit = "in";

export const BoxDimensions = {
  small: {
    dimensions: {
      dimension1: 10,
      dimension2: 10,
      dimension3: 10,
    },
    label: "Small Box",
  },
  medium: {
    dimensions: {
      dimension1: 15,
      dimension2: 15,
      dimension3: 15,
    },
    label: "Medium Box",
  },
  large: {
    dimensions: {
      dimension1: 20,
      dimension2: 20,
      dimension3: 20,
    },
    label: "Large Box",
  },
};

export const BoxTypes = Object.keys(BoxDimensions);

export const SUPPLY_PICKUP_PATH = "/supply-pickup/pickup";

export const buildPickupScheduleWizardState = (pickupMethod, selectedSubmissions = []) => {
  const isDropoff = pickupMethod === "fedex-dropoff";
  const isLocalCourier = pickupMethod === "local-courier";

  let pickupTypeLabel = "FedEx Pickup";
  if (isDropoff) {
    pickupTypeLabel = "FedEx Drop-Off";
  } else if (isLocalCourier) {
    pickupTypeLabel = "Local Courier";
  }

  return {
    pickupTypeKey: pickupMethod,
    pickupTypeLabel,
    phase: "pickup-schedule",
    selectedSubmissions,
  };
};

export const PICKUP_WIZARD_STEPS = [
  { key: "select-submissions", label: "Select Submissions" },
  { key: "pickup-schedule", label: "Pickup Schedule" },
  { key: "packaging-boxes", label: "Packaging Boxes" },
  // { key: "payment", label: "Payment" },
  { key: "summary", label: "Summary" },
];

export const PickupCategoryLabels = {
  fedex: "FedEx Pickup",
  fedex_pickup_labels: "FedEx Pickup",
  fedex_pickup_no_labels: "FedEx Pickup - Billable Stamp",
  billable: "Billable Stamp",
  local_courier: "Local Courier",
  fedex_dropoff: "FedEx Drop-off",
  fedex_dropoff_labels: "FedEx Drop-off",
  fedex_dropoff_no_labels: "FedEx Drop-off - Billable Stamp",
};

export const getPickupCategoryLabel = (pickupCategory) => {
  if (!pickupCategory) return "-";
  return PickupCategoryLabels[pickupCategory] || pickupCategory;
};

export const isFedexPickupCategory = (pickupCategory) => (
  pickupCategory === "fedex"
  || pickupCategory === "fedex_pickup_labels"
  || pickupCategory === "fedex_pickup_no_labels"
);

export const isShippingLabelCategory = (pickupCategory) => (
  pickupCategory === "fedex_pickup_labels"
  || pickupCategory === "fedex_dropoff_labels"
);

const PICKUP_STATUS_DISPLAY = {
  requested: "Pickup Scheduled",
  approved: "Pickup Scheduled",
  picked_up: "Picked Up",
  in_transit: "In Transit",
  delivered: "Received At Lab",
  cancelled: "Cancelled",
};

export const getPickupStatusDisplayLabel = (status, pickupCategory) => {
  if (!status) return "-";
  if (
    (status === "requested" || status === "approved")
    && (
      pickupCategory === "fedex_dropoff"
      || pickupCategory === "fedex_dropoff_labels"
      || pickupCategory === "fedex_dropoff_no_labels"
    )
  ) {
    return "Drop-off Scheduled";
  }
  return PICKUP_STATUS_DISPLAY[status] || status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getPickupStatusBadgeClass = (status, pickupCategory) => {
  if (
    (status === "requested" || status === "approved")
    && (
      pickupCategory === "fedex_dropoff"
      || pickupCategory === "fedex_dropoff_labels"
      || pickupCategory === "fedex_dropoff_no_labels"
    )
  ) {
    return "RequestTableStatusBadge--dropoff_scheduled";
  }
  if (status === "requested" || status === "approved") {
    return "RequestTableStatusBadge--pickup_scheduled";
  }
  if (status === "picked_up") return "RequestTableStatusBadge--picked_up";
  if (status === "in_transit") return "RequestTableStatusBadge--in_transit";
  if (status === "delivered") return "RequestTableStatusBadge--delivered";
  if (status === "cancelled") return "RequestTableStatusBadge--cancelled";
  return "RequestTableStatusBadge--default";
};

const getPickupBoxCount = (row) => {
  const packageCount = Number(row?.package_count);
  return Number.isFinite(packageCount) && packageCount > 0 ? packageCount : 0;
};

const getPickupLabelCountValue = (row) => (
  Array.isArray(row?.fedex_labels) ? row.fedex_labels.length : 0
);

export const formatPickupItemsCell = (row) => {
  const packageCount = getPickupBoxCount(row);
  const weight = typeof row?.total_weight === "string"
    ? row.total_weight.trim()
    : row?.total_weight;

  if (!packageCount && !weight) return "-";

  const boxLabel = `${packageCount || 0} box${packageCount === 1 ? "" : "es"}`;
  if (!weight) return boxLabel;
  return `${boxLabel}: ${weight}`;
};

export const formatPickupLabelsCell = (row) => {
  const count = getPickupLabelCountValue(row);
  if (!count) return "-";
  return String(count).padStart(2, "0");
};

export const getPickupTrackingIdsDisplay = (row) => {
  const fromLabels = (row?.fedex_labels || [])
    .map((label) => label?.tracking_number)
    .filter(Boolean);
  if (fromLabels.length) return fromLabels.join(", ");

  const fromBoxes = (row?.boxes || [])
    .map((box) => box?.tracking_id)
    .filter(Boolean);
  if (fromBoxes.length) return fromBoxes.join(", ");

  return "-";
};

export const getPickupLabelCount = getPickupLabelCountValue;
